export const PLAN_KEYS = ["free", "starter", "growth", "premium", "custom"];

export const PLAN_LABELS = {
  free: "Gratis",
  starter: "Starter",
  growth: "Growth",
  premium: "Premium",
  custom: "Personalizado",
};

export const PLAN_STATUS_LABELS = {
  active: "Activo",
  scheduled: "Programado",
  expired: "Expirado",
  cancelled: "Cancelado",
  suspended: "Suspendido",
  pending_payment_placeholder: "Pago pendiente",
};

export const BILLING_STATUS_LABELS = {
  not_required: "No requerido",
  trial: "Trial",
  pending_manual_invoice: "Factura manual pendiente",
  paid_manual: "Pagado (manual)",
  overdue_placeholder: "Vencido (placeholder)",
  cancelled: "Cancelado",
  not_implemented: "Por implementar",
};

export const PLAN_NOTE_TYPE_LABELS = {
  general: "General",
  pricing: "Pricing",
  billing_placeholder: "Billing",
  negotiation: "Negociación",
  trial_conversion: "Conversión trial",
  custom_terms: "Términos custom",
  cancellation: "Cancelación",
};

export const REPORTS_ACCESS_LABELS = {
  false: "No incluido",
  basic: "Básico",
  full: "Completo",
};

export function trackDealerPlanEvent(eventType, metadata = {}) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.debug("[dealer-plan-event]", eventType, metadata);
  }
}

export function formatPlanLimit(value) {
  if (value == null) return "Ilimitado";
  return String(value);
}

export function planBadgeClass(planKey) {
  if (planKey === "premium") return "admin-badge--success";
  if (planKey === "growth") return "admin-badge--info";
  if (planKey === "starter") return "admin-badge--warning";
  if (planKey === "custom") return "admin-badge--muted";
  return "admin-badge--muted";
}
